import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';

function LtOrderStatusDrawerCtrl($scope, $timeout) {
  LtSelectionDrawerCtrl.call(this, $scope, $timeout);
}

App.controller('LtOrderStatusDrawerCtrl', ['$scope', '$timeout', LtOrderStatusDrawerCtrl]);
